// Dependencies
import { useRef, useEffect, useMemo } from 'react';
import _ from 'lodash';
import _cx from 'classnames';

// Components
import FormGroup from './Groups';
import { Calculator } from './Calculators';
 
// Types
import { Types, Components } from '../../utils/types';
import { DropdownSelect } from "./DropdownSelect";
import { TextField } from "./Fields";
import { FormikContextType, useFormikContext } from "formik";

const FormSection = ({name, label, type, color, textColor, groups, download, calculators, heading, subheading, hasDynamicLabel}: Components.FormSection) => {

    const formSectionRef = useRef<any>(null);
    const { values, isValid, isSubmitting, submitForm }: FormikContextType<any> = useFormikContext();

    // useEffect(() => {
        
    //     if ( type === 'submit' && isValid ) {
    //         formSectionRef.current.scrollIntoView({block: "start", behavior: "smooth", inline: "nearest"}); 
    //     }        

    // }, [])

    const getContactEmail = () => {

        let contactName = 'energy.services';

        if ( ( values['customerType'] === 'domacnost' && values['requestedServices'].includes('elektrina') ) ) {
            contactName = 'doma';
        } else if ( ( values['customerType'] === 'firma' && (values['requestedServices'].includes('elektrina') || values['requestedServices'].includes('plyn') ) ) ) {
            contactName = 'firma';
        }
        
        return `${contactName}@seas.sk`;

    }

    const getSectionLabel = useMemo(() => {

        if ( ! hasDynamicLabel || ! ['section-1'].includes(name) ) {
            return label;
        }

        return [ 
            values['requestedServices'].includes('teplo') ? 'Teplo' : null, 
            values['requestedServices'].includes('chlad') ? 'Chlad' : null 
        ].filter(val => _.isString(val)).join('/');

    }, [hasDynamicLabel, values?.requestedServices]);

    if ( type === 'submit' ) {

        return (
            <div ref={formSectionRef} className={_cx('form-section', type)}>
                <div className="form-section__header"> 
                    <h2>{heading}</h2>
                </div>
                <div className="form-section__fields">
                    { groups.map( (formGroup: Types.FormGroup, order: number) => <FormGroup key={order} {...formGroup} isCurrent={order === groups.length -1} /> ) }
                    <div className="form-group submit">
                        <button className={_cx('form-section__button es-button es-button--cta')} disabled={ ! isValid || isSubmitting} type="button" onClick={submitForm}>Odoslať</button>
                    </div>
                </div>
                <div className="form-section__footer">
                    <p>{subheading} {
                        getContactEmail()
                    }</p>
                </div>
         </div>    
        ) 

    }

    return (
        <div ref={formSectionRef} className={_cx('form-section', type)}>

            {label &&
                <div className="form-section__header">
                    <h2 className="form-section__heading" style={color || textColor ? {backgroundColor: color, color: textColor} : undefined}>
                        <span>{getSectionLabel}</span>
                    </h2>
                    {download && 
                        <h2 className="form-section__heading download-file">
                            <a download href={download?.url}>{download?.label}</a>
                        </h2>
                    }
                </div>
            }   

            <div className="form-section__groups">
                { groups.map( (formGroup: Types.FormGroup, order: number) => <FormGroup key={order} {...formGroup} /> ) }
            </div>

            { !_.isUndefined( calculators ) &&  
                <div className="form-section__calculators">
                    { calculators.map( (calculator: Types.Calculator, order: number) => <Calculator key={order} {...calculator} />) }
                </div>
            }


        </div>
    )

}

export default FormSection;